import { IconWrapper } from '../runtime';
export default IconWrapper('applet-sharing-one', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 48 48",
      "fill": "none"
    }
  }, [h("circle", {
    "attrs": {
      "cx": "24",
      "cy": "24",
      "r": "24",
      "fill": 'url(#' + props.id + 'a1adbd28' + ')'
    }
  }), h("path", {
    "attrs": {
      "d": "M36.2519 16.7711C34.4323 13.0303 29.8399 11.449 26.0274 13.2344C23.9478 14.2036 22.6481 15.8699 22.1455 18.1654C21.6776 20.2569 21.9549 22.5694 22.2322 24.3547C22.5961 26.6332 22.6134 28.3166 22.2842 29.5068C21.9896 30.561 21.4004 31.2582 20.4472 31.7173C19.4594 32.1764 18.3503 32.2274 17.3279 31.8703C16.3054 31.5133 15.4736 30.7821 15.0057 29.8299C14.0352 27.8405 14.9017 25.46 16.9293 24.5078C17.3625 24.3037 17.6918 23.9466 17.8478 23.5046C18.0037 23.0625 17.9864 22.5864 17.7785 22.1613C17.5705 21.7362 17.2065 21.4131 16.756 21.2601C16.3054 21.1071 15.8202 21.124 15.387 21.3281C11.5397 23.1135 9.92809 27.6024 11.7477 31.3432C12.6315 33.1456 14.1739 34.5059 16.1148 35.186C16.9466 35.4751 17.8131 35.6111 18.6796 35.6111C19.8233 35.6111 20.9325 35.3561 21.9722 34.88C24.0518 33.9108 25.3515 32.2614 25.8541 29.9659C26.3047 27.8915 26.0447 25.579 25.7674 23.8106C25.4035 21.4981 25.3862 19.8148 25.7155 18.6245C26.0101 17.5703 26.5993 16.8561 27.5697 16.4141C29.5973 15.4618 32.0408 16.312 33.0113 18.3015C33.9817 20.2909 33.1152 22.6714 31.0877 23.6236C30.2038 24.0487 29.8226 25.0859 30.2385 25.9701C30.4465 26.3952 30.8104 26.7182 31.261 26.8713C31.7115 27.0243 32.1968 27.0073 32.63 26.8033C36.4599 24.9839 38.0715 20.4949 36.2519 16.7711V16.7711Z",
      "fill": "white"
    }
  }), h("defs", [h("linearGradient", {
    "attrs": {
      "id": props.id + 'a1adbd28',
      "x1": "48",
      "y1": "48",
      "x2": "0",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "offset": "0.029618",
      "stop-color": "#7F5DC7"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#967CE2"
    }
  })])])]);
});